import React, { useState } from "react";
import { lightTheme, darkTheme } from "../services/themeStyles.js";

export const ThemeContext = React.createContext({
  currentTheme: "light",
  handleSwitchTheme: () => {},
});

export function ThemeProvider(props) {
  const [currentTheme, setTheme] = useState("light");

  const handleSwitchTheme = () => {
    const nextTheme = currentTheme === "light" ? "dark" : "light";
    setTheme(nextTheme);
    applyTheme(nextTheme);
  };

  const applyTheme = (nextTheme) => {
    const theme = nextTheme === "dark" ? darkTheme : lightTheme;
    Object.keys(theme).map((key) => {
      const value = theme[key];
      document.documentElement.style.setProperty(key, value);
    });
  };

  return (
    <ThemeContext.Provider
      value={{
        currentTheme,
        handleSwitchTheme,
      }}
    >
      {props.children}
    </ThemeContext.Provider>
  );
}
